import {
CREATE_MIXPANEL_EVENT_REQUEST, CREATING_MIXPANEL_EVENT_SUCCEEDED, CREATING_MIXPANEL_EVENT_FAILED,
IDENTIFY_MIXPANEL_USER_REQUEST, IDENTIFY_MIXPANEL_USER_SUCCEEDED, IDENTIFY_MIXPANEL_USER_FAILED
} from 'constants/actionTypes';

import { put, call, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import axios from 'axios';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const MIXPANEL_URL = `${apiUrl}/api/2.0/mixpanel`;

/**
 * Create mixpanel event
*/
export const createMixpanelEvent = createAction(CREATE_MIXPANEL_EVENT_REQUEST, (event, properties) => {
  return {
    event: event,
    properties: properties
  }
})

export const createMixpanelEventSucceeded = createAction(CREATING_MIXPANEL_EVENT_SUCCEEDED, (response) => {
  return {
    response: response
  };
})

export const createMixpanelEventFailed = createAction(CREATING_MIXPANEL_EVENT_FAILED, (error) => {
  return error;
})

function* createMixpanelEventSaga(action) {
  const { event, properties } = action.payload;

  const url = `${MIXPANEL_URL}/event`;

  const request = {
    properties: JSON.stringify(properties),
    event: event,
  }

  const createMixpanelEventAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createMixpanelEventAPI);
    if (response) {
      yield put(createMixpanelEventSucceeded(response));
    }
  } catch (error) {
    yield put(createMixpanelEventFailed(error));
  }
}

/**
 * Identify mixpanel user
*/

export const identifyMixpanelUser = createAction(IDENTIFY_MIXPANEL_USER_REQUEST, (id) => {
  return {
    id: id,
  }
})

export const identifyMixpanelUserSucceeded = createAction(IDENTIFY_MIXPANEL_USER_SUCCEEDED, (response) => {
  return {
    response: response
  };
})

export const identifyMixpanelUserFailed = createAction(IDENTIFY_MIXPANEL_USER_FAILED, (error) => {
  return error;
})

function* identifyMixpanelUserSaga(action) {
  const { id } = action.payload;

  const url = `${MIXPANEL_URL}/identify/${id}`;

  const identifyMixpanelUserAPI = () => {
    return axios.post(url, {}).then(response => response.data);
  }

  try {
    const response = yield call(identifyMixpanelUserAPI);
    if (response) {
      yield put(identifyMixpanelUserSucceeded(response));
    }
  } catch (error) {
    yield put(identifyMixpanelUserFailed(error));
  }
}

export default function* mixPanelSaga() {
  yield takeEvery(CREATE_MIXPANEL_EVENT_REQUEST, createMixpanelEventSaga);
  yield takeEvery(IDENTIFY_MIXPANEL_USER_REQUEST, identifyMixpanelUserSaga);
}